export default __webpack_public_path__ + "static/media/Gray-Instagram.fc3e8299.svg";